import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Megaphone } from "lucide-react";
import { toast } from "sonner";
import { api, apiErr } from "@/lib/api";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { DaytimeDayView } from "./DaytimeDayView";
import { DaytimeDates } from "./DaytimeDates";
import { DaytimeMembers } from "./DaytimeMembers";
import { DaytimeSettings } from "./DaytimeSettings";
import { DaytimeWaitlist } from "./DaytimeWaitlist";
import { AddonsAdmin } from "./AddonsAdmin";
import { AddonsSettings } from "./AddonsSettings";
import { GiftsAdmin } from "./GiftsAdmin";
import { DaytimeReports } from "./DaytimeReports";

export function DaytimeAdmin() {
  const [t, setT] = useState("today");
  const announce = async () => {
    if (!window.confirm("Post 3 in-app announcements (Daytime Open Play, Amazing Add-Ons, Gift a Rock Pass) to every registered parent?")) return;
    try { const { data } = await api.post("/daytime/admin/announce"); toast.success(`Announced to ${data.parents_notified} parents`); } catch (e) { toast.error(apiErr(e)); }
  };
  return (
    <div className="space-y-3" data-testid="daytime-admin">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <p className="text-sm text-slate-500">Daytime Day Passes · timed 2-hour, 4-hour & all-day sessions.</p>
        <Button size="sm" variant="outline" className="rounded-full" onClick={announce} data-testid="daytime-announce-btn"><Megaphone className="w-4 h-4 mr-1" /> Announce to parents</Button>
      </div>
      <Tabs value={t} onValueChange={setT}>
        <TabsList className="flex-wrap h-auto bg-white border border-slate-200 rounded-xl p-1">
          {[["today", "Bookings & attendance"], ["dates", "Dates & capacity"], ["members", "Memberships & passes"], ["waitlist", "Waitlist"], ["addons", "Add-on requests"], ["addonset", "Add-on pricing & staff"], ["gifts", "Gift cards"], ["reports", "Reports"], ["settings", "Pricing & rules"]].map(([k, l]) => (
            <TabsTrigger key={k} value={k} className="rounded-lg data-[state=active]:bg-navy data-[state=active]:text-white" data-testid={`daytime-subtab-${k}`}>{l}</TabsTrigger>
          ))}
        </TabsList>
        <TabsContent value="today"><DaytimeDayView /></TabsContent>
        <TabsContent value="dates"><DaytimeDates /></TabsContent>
        <TabsContent value="members"><DaytimeMembers /></TabsContent>
        <TabsContent value="waitlist"><DaytimeWaitlist /></TabsContent>
        <TabsContent value="addons"><AddonsAdmin /></TabsContent>
        <TabsContent value="addonset"><AddonsSettings /></TabsContent>
        <TabsContent value="gifts"><GiftsAdmin /></TabsContent>
        <TabsContent value="reports"><DaytimeReports /></TabsContent>
        <TabsContent value="settings"><DaytimeSettings /></TabsContent>
      </Tabs>
    </div>
  );
}
